import { render } from "./Error.vue?vue&type=template&id=58a58c68&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-58a58c68"

export default script